import * as React from 'react';
import { cn } from './cn';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
	padding?: 'none' | 'sm' | 'md' | 'lg';
	hoverable?: boolean;
}

const padMap = {
	none: '',
	sm: 'p-4',
	md: 'p-5 sm:p-6',
	lg: 'p-6 sm:p-8',
};

export function Card({
	padding = 'md',
	hoverable,
	className,
	children,
	...rest
}: CardProps) {
	return (
		<div
			className={cn(
				'bg-ground-card rounded-xl border border-slate-200 shadow-card',
				padMap[padding],
				hoverable && 'transition-shadow hover:shadow-cardHover',
				className
			)}
			{...rest}
		>
			{children}
		</div>
	);
}

export function CardHeader({
	title,
	description,
	actions,
	className,
}: {
	title: React.ReactNode;
	description?: React.ReactNode;
	actions?: React.ReactNode;
	className?: string;
}) {
	return (
		<div className={cn('flex items-start justify-between gap-3 mb-4', className)}>
			<div>
				<h3 className="section-title">{title}</h3>
				{description && (
					<p className="text-sm text-ink-muted mt-0.5">{description}</p>
				)}
			</div>
			{actions && <div className="flex-shrink-0">{actions}</div>}
		</div>
	);
}

export default Card;
